import {
  SET_CURRENT_PICKLIST,
  SET_PICKLIST_DETAILS_ASSETS_COUNTING,
  SET_PICKLIST_DETAILS_STATUSES,
  SET_PICKLIST_DETAILS_PICKLIST_ASSETS,
  SET_PICKLIST_DETAILS_FILTER,
  SET_PICKLIST_DETAILS_FILTER_CRITERIA,
  CLEAR_PICKLIST_DETAILS_STATE,
  SET_BILL_OF_LADING_CREATION_FORM,
  SET_PICKLIST_DETAILS_PICKLIST_LOOSE_ITEMS,
  SET_PICKLIST_DETAILS_PICKLIST_ASSEMBLIES
} from '../constants/reduceConstants';
import api from '../api';
import { SUCCESS_DELETE_PICKLIST } from '../constants/infoSnackbarData';
import { browserHistory } from '../browserHistory';
import { BILL_OF_LADING_EDIT_PATH, PICKLIST_SUMMARY_PATH } from '../constants/routeConstants';
import { enqueueErrorSnackbar, enqueueSuccessSnackbar } from 'helpers/AppHelpers';

export const getPicklist = (id) => (dispatch) =>
  api.picklistDetails
    .getPicklistApi(id)
    .then((res) => {
      dispatch({ type: SET_CURRENT_PICKLIST, payload: res });
      return res;
    })
    .catch((err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      browserHistory.push(PICKLIST_SUMMARY_PATH);
    });

export const getCsvResource = (q) => () =>
  api.picklistDetails
    .getCsvResourceApi(q)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getCounting = (query) => (dispatch) =>
  api.picklistDetails
    .getCountingApi(query)
    .then((res) => dispatch({ type: SET_PICKLIST_DETAILS_ASSETS_COUNTING, payload: res }))
    .catch((err) => console.log(err));

export const getPicklistStatuses = () => (dispatch) =>
  api.picklistDetails
    .getPicklistStatusesApi()
    .then((res) => dispatch({ type: SET_PICKLIST_DETAILS_STATUSES, payload: res }))
    .catch((err) => console.log(err));

export const getFilterCriteria = (query) => (dispatch) =>
  api.picklistDetails
    .getFilterCriteriaApi(query)
    .then((res) => {
      dispatch({ type: SET_PICKLIST_DETAILS_FILTER_CRITERIA, payload: res });
      return res;
    })
    .catch((err) => console.log(err));

export const setPicklistAssets = (payload) => (dispatch) =>
  dispatch({ type: SET_PICKLIST_DETAILS_PICKLIST_ASSETS, payload });

export const setPicklistLooseItems = (payload) => (dispatch) =>
  dispatch({ type: SET_PICKLIST_DETAILS_PICKLIST_LOOSE_ITEMS, payload });

export const setPicklistAssemblies = (payload) => (dispatch) =>
  dispatch({ type: SET_PICKLIST_DETAILS_PICKLIST_ASSEMBLIES, payload });

export const setFilter = (payload) => (dispatch) =>
  dispatch({ type: SET_PICKLIST_DETAILS_FILTER, payload });

export const clearState = () => (dispatch) => dispatch({ type: CLEAR_PICKLIST_DETAILS_STATE });

export const getPicklistAssets = (query) => () =>
  api.picklistDetails
    .getAssetsApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const updatePicklistAsset = (data) => () =>
  api.picklistDetails.updatePicklistAssetApi(data).then(
    (res) => res,
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    }
  );

export const deletePicklist = (id) => () =>
  api.picklistDetails.deletePicklistApi(id).then(
    () => {
      enqueueSuccessSnackbar(SUCCESS_DELETE_PICKLIST);
      browserHistory.push(PICKLIST_SUMMARY_PATH);
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
    }
  );

export const deletePicklistAssets = (data) => () =>
  api.picklistDetails.deletePicklistAssets(data).then(
    (res) => res,
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    }
  );

export const checkBillOfLadingItems = (data) => (dispatch) =>
  api.picklistDetails.checkBillOfLadingItemsApi(data).then(
    (res) => {
      if (res.status === 200) {
        dispatch({ type: SET_BILL_OF_LADING_CREATION_FORM, payload: res.data });
        browserHistory.push(BILL_OF_LADING_EDIT_PATH);
      }
      return res;
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      return errors;
    }
  );

export const deleteFileFromAsset = (fileId) => () =>
  api.common
    .deleteFileApi(fileId)
    .then((res) => res)
    .catch((err) => console.log(err));

export const checkPicklistAssetsLocation = (query) => () =>
  api.picklistDetails
    .checkPicklistAssetsLocationApi(query)
    .then((res) => res)
    .catch((err) => console.log(err));

export const addAssemblyToPicklist = (data) => () =>
  api.picklistDetails
    .addAssemblyToPicklistApi(data)
    .then((res) => res)
    .catch((err) => console.log(err));
